import { useMemo } from 'react';

// ts-prune-ignore-next
export const disableWhenAlone: <T extends { disabled?: boolean }>(
    tracks: readonly T[]
) => readonly T[] = (tracks) =>
    tracks.length === 1 && tracks[0]
        ? [
              {
                  ...tracks[0],
                  disabled: true,
              },
          ]
        : tracks;

export const useDisableWhenAlone: <T extends { disabled?: boolean }>(
    tracks: readonly T[]
) => readonly T[] = (tracks) => useMemo(() => disableWhenAlone(tracks), [tracks]);
